import SpecialPage from './ui/SpecialPage'

export default SpecialPage
